import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomDateAdapter } from '../../../../shared/custom-date-adapter';
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { DateTimePickerComponent } from '../../../formio/datetime-picker/datetime-picker.component';
import { DocumentClassComponent } from '../../flow-object/_edocs-fields/document-class/document-class.component';
import { AccessLevelComponent } from '../../flow-object/_edocs-fields/access-level/access-level.component';

export const IMPORTS = [
    CommonModule,
    FormsModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxMatDatetimePickerModule,
    MatIconModule,
    DateTimePickerComponent,
    DocumentClassComponent,
    AccessLevelComponent,
];

export const PROVIDERS = [
    {
        provide: NGX_MAT_DATE_FORMATS,
        useValue: {
            parse: {
                dateInput: "DD/MM/YYYY, [às] HH:mm:ss"
            },
            display: {
                dateInput: "DD/MM/YYYY, [às] HH:mm:ss",
                monthYearLabel: "MMM YYYY",
                dateA11yLabel: "LLL",
                monthYearA11yLabel: "MMMM YYYY"
            }
        }
    },
    { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
];
